import React, { useEffect, useState } from 'react';
import { Search, RefreshCw, Wallet, ArrowUpCircle, ArrowDownCircle, CircleDollarSign } from 'lucide-react';
import { paymentsService } from '../services/api';
import { BrandSpinnerRing } from '../components/SiteBrandedLoader';

const WalletTransactions: React.FC = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState({ total: 0, page: 1, limit: 20, totalPages: 1 });
  const [status, setStatus] = useState('');
  const [type, setType] = useState('');
  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');

  const fetchData = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await paymentsService.getAdminWalletTransactions({
        page,
        limit: 20,
        status: status || undefined,
        type: type || undefined,
        search: search.trim() || undefined,
      });
      setRows(Array.isArray(res?.data) ? res.data : []);
      setMeta(res?.meta || { total: 0, page: 1, limit: 20, totalPages: 1 });
    } catch (err: any) {
      setError(err?.response?.data?.message || 'خطا در دریافت تراکنش‌ها');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, status, type]);

  const stats = {
    total: Number(meta.total || 0),
    charges: rows.filter((r) => r.type === 'WALLET_CHARGE').length,
    deductions: rows.filter((r) => r.type === 'WALLET_DEDUCTION').length,
    paid: rows.filter((r) => r.status === 'PAID').length,
  };

  return (
    <div className="space-y-5">
      <div className="rounded-2xl bg-white p-5 shadow-sm sm:p-6">
        <h1 className="text-xl font-black text-gray-900 sm:text-2xl">تراکنش‌های کیف پول</h1>
        <p className="mt-1.5 text-sm font-medium text-gray-600">
          رهگیری حرفه‌ای همه تراکنش‌های کیف پول کاربران با وضعیت، مانده و جزئیات کامل.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <div className="rounded-2xl border border-indigo-100 bg-gradient-to-b from-indigo-50 to-white p-4 shadow-sm"><div className="flex items-start justify-between"><div><p className="text-xs font-bold text-indigo-700">کل تراکنش‌ها</p><p className="mt-2 text-2xl font-black text-indigo-900">{stats.total.toLocaleString('fa-IR')}</p></div><span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-indigo-100 text-indigo-700"><Wallet className="h-4 w-4" /></span></div></div>
        <div className="rounded-2xl border border-emerald-100 bg-gradient-to-b from-emerald-50 to-white p-4 shadow-sm"><div className="flex items-start justify-between"><div><p className="text-xs font-bold text-emerald-700">شارژها</p><p className="mt-2 text-2xl font-black text-emerald-900">{stats.charges.toLocaleString('fa-IR')}</p></div><span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-100 text-emerald-700"><ArrowUpCircle className="h-4 w-4" /></span></div></div>
        <div className="rounded-2xl border border-amber-100 bg-gradient-to-b from-amber-50 to-white p-4 shadow-sm"><div className="flex items-start justify-between"><div><p className="text-xs font-bold text-amber-700">کسرها</p><p className="mt-2 text-2xl font-black text-amber-900">{stats.deductions.toLocaleString('fa-IR')}</p></div><span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-amber-100 text-amber-700"><ArrowDownCircle className="h-4 w-4" /></span></div></div>
        <div className="rounded-2xl border border-blue-100 bg-gradient-to-b from-blue-50 to-white p-4 shadow-sm"><div className="flex items-start justify-between"><div><p className="text-xs font-bold text-blue-700">موفق</p><p className="mt-2 text-2xl font-black text-blue-900">{stats.paid.toLocaleString('fa-IR')}</p></div><span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-blue-100 text-blue-700"><CircleDollarSign className="h-4 w-4" /></span></div></div>
      </div>

      <div className="rounded-2xl bg-white p-4 shadow-sm sm:p-5">
        <div className="flex flex-wrap items-center gap-2">
          <div className="relative min-w-[16rem] flex-1">
            <Search className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <input
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            placeholder="جستجو: نام، موبایل، ایمیل، توضیحات..."
              className="w-full rounded-xl border border-slate-200 py-2.5 pr-9 pl-3 text-sm"
          />
          </div>
          <select value={status} onChange={(e) => setStatus(e.target.value)} className="rounded-xl border border-slate-200 px-3 py-2.5 text-sm">
            <option value="">همه وضعیت‌ها</option>
            <option value="PAID">موفق</option>
            <option value="PENDING">در انتظار</option>
            <option value="FAILED">ناموفق</option>
            <option value="CANCELLED">لغو شده</option>
          </select>
          <select value={type} onChange={(e) => setType(e.target.value)} className="rounded-xl border border-slate-200 px-3 py-2.5 text-sm">
            <option value="">همه نوع‌ها</option>
            <option value="WALLET_CHARGE">شارژ کیف پول</option>
            <option value="WALLET_DEDUCTION">کسر از کیف پول</option>
            <option value="COURSE_PURCHASE">خرید دوره</option>
          </select>
          <button
            onClick={() => { setPage(1); setSearch(searchInput.trim()); fetchData(); }}
            className="rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-black text-white"
          >
            جستجو و فیلتر
          </button>
          <button
            onClick={() => fetchData()}
            className="inline-flex items-center gap-1 rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-xs font-black text-slate-700"
          >
            <RefreshCw className="h-3.5 w-3.5" />
            بروزرسانی
          </button>
        </div>
      </div>

      {error ? <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-700">{error}</div> : null}

      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm ring-1 ring-slate-100">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[1100px]">
            <thead className="bg-gradient-to-l from-slate-50 via-white to-slate-50/80">
              <tr className="text-right text-[11px] font-black uppercase text-slate-600">
                <th className="px-3 py-3">کاربر</th>
                <th className="px-3 py-3">نوع</th>
                <th className="px-3 py-3">وضعیت</th>
                <th className="px-3 py-3">مبلغ</th>
                <th className="px-3 py-3">مانده بعد</th>
                <th className="px-3 py-3">توضیحات</th>
                <th className="px-3 py-3">تاریخ</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={7} className="px-3 py-10 text-center"><BrandSpinnerRing size="sm" /></td></tr>
              ) : rows.length === 0 ? (
                <tr><td colSpan={7} className="px-3 py-10 text-center text-sm text-slate-500">تراکنشی یافت نشد</td></tr>
              ) : rows.map((row) => (
                <tr key={row.id} className="border-t border-slate-100 text-sm transition hover:bg-indigo-50/30">
                  <td className="px-3 py-3">
                    <p className="font-bold text-slate-900">{`${row.user?.firstName || ''} ${row.user?.lastName || ''}`.trim() || row.user?.username || 'کاربر'}</p>
                    <p className="text-xs text-slate-500">{row.user?.phone || row.user?.email || '-'}</p>
                  </td>
                  <td className="px-3 py-3">{row.type === 'WALLET_CHARGE' ? 'شارژ کیف پول' : row.type === 'WALLET_DEDUCTION' ? 'کسر از کیف پول' : row.type}</td>
                  <td className="px-3 py-3">
                    <span className={`rounded-full px-2 py-0.5 text-xs font-bold ${
                      row.status === 'PAID' ? 'bg-emerald-100 text-emerald-700' : row.status === 'FAILED' ? 'bg-rose-100 text-rose-700' : 'bg-amber-100 text-amber-700'
                    }`}>
                      {row.status === 'PAID' ? 'موفق' : row.status === 'FAILED' ? 'ناموفق' : row.status}
                    </span>
                  </td>
                  <td className="px-3 py-3 font-black text-[#1C3B9B]">{Number(row.amount || 0).toLocaleString('fa-IR')} تومان</td>
                  <td className="px-3 py-3">{Number(row.balanceAfter || 0).toLocaleString('fa-IR')} تومان</td>
                  <td className="px-3 py-3 text-xs text-slate-600">{row.description || '-'}</td>
                  <td className="px-3 py-3 text-xs text-slate-500">{new Date(row.createdAt).toLocaleString('fa-IR')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="flex items-center justify-between rounded-xl border border-slate-200 bg-white px-4 py-2.5">
        <p className="text-xs font-semibold text-slate-600">تعداد کل: {Number(meta.total || 0).toLocaleString('fa-IR')}</p>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page <= 1}
            className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-bold disabled:opacity-50"
          >
            قبلی
          </button>
          <span className="text-xs font-bold text-slate-700">{Number(page).toLocaleString('fa-IR')} / {Number(meta.totalPages || 1).toLocaleString('fa-IR')}</span>
          <button
            type="button"
            onClick={() => setPage((p) => Math.min(Number(meta.totalPages || 1), p + 1))}
            disabled={page >= Number(meta.totalPages || 1)}
            className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-bold disabled:opacity-50"
          >
            بعدی
          </button>
        </div>
      </div>
    </div>
  );
};

export default WalletTransactions;
